import { useState } from "react";
import { PortInStep } from "../portInStep";
import { otpValidate } from "./verifyCodeApi";
import { UseFormMethods, useWatch } from "react-hook-form";
import { IPortinForm } from "../../IPortinForm";
import { ValidationCodeView } from "./validationCodeView";

interface IParams {
    otpId: string;
    variantStyleButton: "outlined" | "contained";
    setIsFinished(newValue: boolean): void;
    updatePortInStep(nextStep: PortInStep): void;
    setHasTooManyAttempt(hasTooManyAttempt: boolean): void;
    formMethods: UseFormMethods<IPortinForm>;
}

export const ValidationCode = (props: IParams) => {
    const { formMethods, otpId, setIsFinished, updatePortInStep, variantStyleButton, setHasTooManyAttempt } = props;

    const [userAttempt, setUserAttempt] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const incrementUserAttempt = () => {
        setUserAttempt(userAttempt + 1);
    };

    const resetUserAttempt = () => {
        setUserAttempt(0);
    };

    const retryCode = () => {
        updatePortInStep(PortInStep.getCode);
    };

    const validationCodeValue = useWatch<string>({
        name: "validationCode",
        control: formMethods.control,
        defaultValue: "",
    });

    const validateCode = async () => {
        if (await formMethods.trigger("validationCode")) {
            setIsLoading(true);

            otpValidate(setErrorMessage, validationCodeValue, otpId).then((responseValidate) => {
                if (responseValidate?.valid) {
                    updatePortInStep(PortInStep.successCode);
                    setIsFinished(true);
                } else {
                    if (userAttempt < 2) {
                        incrementUserAttempt();
                        setIsLoading(false);
                    } else {
                        resetUserAttempt();
                        setHasTooManyAttempt(true);
                        updatePortInStep(PortInStep.getCode);
                    }
                }
            });
        }
    };

    return (
        <ValidationCodeView
            error={formMethods.errors.validationCode}
            errorMessage={errorMessage}
            isLoading={isLoading}
            register={formMethods.register}
            retryCode={retryCode}
            validateCode={validateCode}
            variantStyleButton={variantStyleButton}
        />
    );
};
